'use client'

import { storeFutuExchange } from "@/shared/store/exchange"
import { useSession } from "../providers/session"
import { useEffect } from "react"
import { storeFutuUserInfo } from "@/shared/store/userInfo"
import { storeFutuWSUser } from "@/shared/store/wsUsers"
import { useManagementDataStore } from "@/features/management/model/managementData"
import { apiFe } from "@/shared/api"
import { useRouter } from "next/navigation"
// 클라이언트에서 세션 업데이트 금지: 서버 라우트 통해 처리

export const useLoginInit = () => {
  const session = useSession()
  const router = useRouter()
  const {
    fetchFilledList,
    fetchBotList,
    fetchTemporaryList,
  } = useManagementDataStore()

  useEffect(() => {
    // session이 null이면 아무것도 하지 않음
    if (!session) return

    if (session.NewAuthToken) {
      let didConnect = false

        ; (async () => {
          try {
            const { data } = await apiFe.post<postPrivacyCheckRes & { needsRedirect?: string }>('/policy/privacy-check')

            // 리다이렉트가 필요한 경우 처리
            if (data.needsRedirect) {
              router.replace(data.needsRedirect)
              return
            }

            // 동의 값이 'N'이면 아래 초기화 로직 수행 안 함
            if (data.result_code !== '100' || data.pol_privacy_yn === 'N') return

            // 로그인 시 필요한 초기화 로직
            const { BinanceLeverageBrackets } = storeFutuExchange.getState()
            const { InitLoginInfo } = storeFutuUserInfo.getState()
            const { connect } = storeFutuWSUser.getState()

            BinanceLeverageBrackets()
            InitLoginInfo()
            connect(); didConnect = true

            // 관리 데이터 호출
            fetchFilledList()
            fetchBotList()
            fetchTemporaryList()
          } catch (e) { }
        })()

      return () => {
        if (didConnect) {
          const { unConnect } = storeFutuWSUser.getState()
          unConnect()
        }
      }
    }
  }, [session?.NewAuthToken, router])
}